module.exports = __webpack_public_path__ + "static/media/chantefrance.6f68a659.png";